<template>
  <modal
    :center="false"
    :show="visible"
    @close="visible = false"
    modalClasses="modal-xxl"
  >
    <div slot="header">
      <h3><i class="fa fa-history" aria-hidden="true"></i> Lịch sử báo giá</h3>
    </div>
    <block ref="bmdal" class="soft-control">
      <base-table :data="tableData">
        <template slot="columns">
          <th>STT</th>
          <th>Khách hàng</th>
          <th>Sản phâm</th>
          <th>Quy cách</th>
          <th class="text-right">Chiều dài</th>
          <th>Hệ màu</th>
          <th>Màu sắc</th>
          <th class="text-right">Đơn giá</th>
          <th class="text-right">Số lượng từ</th>
          <th></th>
          <th>Ngày báo giá</th>
          <th>Ghi chú</th>
        </template>

        <template slot-scope="{ row, index }">
          <tr :key="index">
            <td class="bg-info text-light col-fix ">
              {{ index + 1 }}
            </td>
            <td>
              <b>{{ row.customer.code }}</b> <br />{{ row.customer.name }}
            </td>
            <td>
              <b>{{ row.product.code }}</b> <br />{{ row.product.name }}
            </td>
            <td class="text-center">{{ row.productSpecify.name }}mm</td>
            <td class="text-center">{{ $formatNumber(row.length) }} cm</td>
            <td class="text-center">
              <span v-if="row.color">{{ row.color.label }}</span>
              <br />
              {{ row.colorCode }}
            </td>
            <td class="text-center">{{ row.colorText }}</td>
            <td class="text-right col-fix">
              {{ $formatNumber(row.price) }} {{ row.currency }}/ {{ row.unit }}
            </td>
            <td class="text-right col-fix">
              {{ $formatNumber(row.quantity) }} {{ row.unit }}
            </td>
            <td class="col-fix text-center">
              <b-button
                @click="choosePrice(row)"
                variant="outline-success px-1 py-0"
              >
                <i class="fa fa-check" aria-hidden="true"></i> Chọn giá này
              </b-button>
            </td>
            <td>{{ $dateTimeUnix(row.dateCreated) }}</td>
            <td><span v-html="row.note"></span></td>
          </tr>
        </template>
      </base-table>
      <div>
        <pagination
          class="mt-2 mb-2 mr-2"
          slot="footer"
          :total="query.total"
          :perPage="query.limit"
          @change="pagChange"
        />
      </div>
    </block>
    <b-row align-h="center">
      <b-col sm="12" md="4">
        <b-button class="mb-2" block variant="secondary" @click="handleClose">
          Đóng (Esc)
        </b-button>
      </b-col>
    </b-row>
    <event @doCancel="handleClose"></event>
  </modal>
</template>
<script>
import { quotaService } from "@/_services";
export default {
  props: {},
  data() {
    return {
      visible: false,
      query: {
        limit: 10,
        page: 1,
        productId: 0,
        specId: "",
        color: "",
        total: 1
      },
      tableData: []
    };
  },
  methods: {
    setData({ productId, specId, color, customerId }) {
      this.query.productId = productId;
      this.query.specId = specId;
      this.query.color = color.id;
      this.query.customerId = customerId;
      this.fetchData();
    },
    pagChange(page) {
      this.query.page = page;
      this.fetchData();
    },
    fetchData() {
      this.$refs.bmdal.block();
      quotaService
        .history(this.query)
        .then(res => {
          this.tableData = res.data.data;
          this.query.total = res.data.total;
        })
        .finally(() => {
          this.$refs.bmdal.unBlock();
        });
    },
    handleClose() {
      this.visible = false;
    },
    doPrint() {
      this.$print("print");
    },
    choosePrice(row) {
      this.$emit("choosePrice", row.price);
      this.visible = false;
    },
    doSave() {
      this.$refs.bmdal.block();
      this.$emit("doSave", () => {
        this.quotation.id = true;
        this.$refs.bmdal.unBlock();
      });
    }
  }
};
</script>
